import React from "react";
import ProjectStudentSection from "../../Sections/ProjectStudentSection/Content";
const ProjectStudentPage = () => {
  return <ProjectStudentSection />;
};

export default ProjectStudentPage;
